import GeneralSearchPanel from "./generalSearch.container";

export default GeneralSearchPanel;
